export const itemsBaseApiPath = '/api/common/storefront-bulk-actions';

import { fetchItemsGen } from '../../../utils/apiHelperGenerators.js';

export const fetchItems = fetchItemsGen(itemsBaseApiPath, 'listItems');

export const getItemById = id => {
  return new Promise((resolve, reject) => {
    $http
      .get(itemsBaseApiPath + '/' + id)
      .then(resp => {
        resolve(resp);
      })
      .catch(error => {
        console.error('getItemById error', error);
        reject(error);
      });
  });
};

export default {
  fetchItems,
  getItemById
};
